import { render, staticRenderFns } from "./completeness-check-modal-comments-tab.vue?vue&type=template&id=01016da2"
import script from "./completeness-check-modal-comments-tab.vue?vue&type=script&lang=ts"
export * from "./completeness-check-modal-comments-tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01016da2')) {
      api.createRecord('01016da2', component.options)
    } else {
      api.reload('01016da2', component.options)
    }
    module.hot.accept("./completeness-check-modal-comments-tab.vue?vue&type=template&id=01016da2", function () {
      api.rerender('01016da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/completeness-check/completeness-check-details-modal/completeness-check-modal-comments-tab/completeness-check-modal-comments-tab.vue"
export default component.exports